import React from 'react'
import Projects from '../components/Projects/Projects'

const Project = () => {
  return (
    <div>
        <Projects />
    </div>
  )
}

export default Project